import { FileBasic } from '@commenda/types/src/file/types';
import { Country } from '@prisma/client';

export {
  CertificateTypeEnum,
  ExemptionIdTypeEnum,
  ExemptionReasonEnum,
  ExemptionStatusEnum,
  VerificationStatusEnum,
} from '../../common/types';

import {
  CertificateTypeEnum,
  ExemptionIdTypeEnum,
  ExemptionReasonEnum,
  ExemptionStatusEnum,
  VerificationStatusEnum,
} from '../../common/types';

export interface JurisdictionExemption {
  country: Country;
  state: string;
  reason: ExemptionReasonEnum;
  is_active: boolean;
  end_date: string;
  identification_type: ExemptionIdTypeEnum;
  identification_number: string;
  is_expired: boolean;
}

export interface CreateJurisdictionExemption {
  country: Country;
  state: string;
  identification_type: ExemptionIdTypeEnum;
  identification_number: string;
}

export interface ExemptionCertificate {
  id: string;
  customer_id: string;
  type: CertificateTypeEnum;
  verification_status: VerificationStatusEnum;
  exemption_certificate_number?: string;
  effective_date: string;
  created_at: number;
  jurisdictions: JurisdictionExemption[];
  file_id?: string;
}

export interface CreateExemptionCertificate {
  customer_id: string;
  type: CertificateTypeEnum;
  exemption_certificate_number?: string;
  effective_date: string;
  jurisdictions: CreateJurisdictionExemption[];
  file_id?: number;
  corporation_id: number;
  expiration_date?: string;
  reason: ExemptionReasonEnum;
}

export interface CreateExemptionCertificateByBuyer {
  customerSellerRelationshipId: string;
  type: CertificateTypeEnum;
  exemption_certificate_number?: string;
  effective_date: string;
  jurisdictions: CreateJurisdictionExemption[];
  file_id?: number;
  expiration_date?: string;
  reason: ExemptionReasonEnum;
}

export interface UpdateExemptionCertificate {
  exemption_certificate_number?: string;
  effective_date: string;
  file_id?: string;
  corporation_id: number;
}

export interface UpsertJurisdictionExemptionBulkType {
  jurisdictions: CreateJurisdictionExemption[];
  corporation_id: number;
}

export interface ExemptionCertificateListData {
  exemption_certificates: ExemptionCertificate[];
  cursor: string;
  total_exemption_certificates: number;
}

export type ExemptionCertificateDeleteResponse = void;
export type JurisdictionExemptionDeleteResponse = void;

export interface ExemptionCertificateResponse {
  data: ExemptionCertificate;
  message: string;
}
export interface JurisdictionExemptionResponse {
  data: JurisdictionExemption;
  message: string;
}

export interface ExemptionCertificateListResponse {
  data: ExemptionCertificateListData;
  message: string;
}

export interface ExemptionCertificateUpdateResponse {
  message: string;
}

export interface JurisdictionExemptionUpdateResponse {
  message: string;
}

export interface ExemptionCertificateQueryParams {
  corporation_id: number;
  customer_id: string;
  limit?: number;
  cursor?: string;
}

export interface ExemptionCertificateFileData {
  id: string;
  name: string;
  size: number;
  created_at: string;
}

export interface ExemptionCertificateFileWithSignedUrl
  extends ExemptionCertificateFileData {
  signed_url: string;
}

export interface ExemptionCertificateFileUploadResponse {
  data: ExemptionCertificateFileData;
  message: string;
}

export interface ExemptionCertificateFileGetResponse {
  data: ExemptionCertificateFileWithSignedUrl;
  message: string;
}

export type ExemptionCertificateFileUploadPayload = {
  file: FileBasic;
  corporation_id: number;
};
